import {ElementRef, EventEmitter} from "@angular/core";
import {AbstractControl} from '@angular/forms';

export class InputType {
  public errorKey!: string;
  public focusOut!: EventEmitter<string | Event>;
  public keyUp!: EventEmitter<string>;
  public setId!: (id: string | number) => void;
  public getFormControl!: () => AbstractControl;
  public getAttribute!: (attribute: string) => string;
  public setAttribute!: (attribute: { name: string; value: string }) => void;
  public performSubmit!: () => void;
  public getElementRef!: () => ElementRef;
}
